var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSeta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.364,
    height: 9.604,
    viewBox: "0 0 16.364 9.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5b6480;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-2116.382,9.709a1.5,1.5,0,0,1-.193-.163l-6.364-6.364a1.5,1.5,0,0,1,0-2.121,1.5,1.5,0,0,1,2.12,0l5.621,5.621,5.622-5.622a1.5,1.5,0,0,1,2.121,0,1.5,1.5,0,0,1,0,2.121l-6.364,6.364q-.048.048-.1.091a1.741,1.741,0,0,1-1.28.589A1.655,1.655,0,0,1-2116.382,9.709Z",
    transform: "translate(2123.378 -0.621)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeta);
export default __webpack_public_path__ + "static/media/icon_seta.61f28562a9b5024926487a456eb21ea8.svg";
export { ForwardRef as ReactComponent };